import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {ApiService} from "../../services/api/api.service";
import {SeriesDataService} from '../../services/series_data.service';
import {SeriesSummaryConfig} from '../../services/context.service';
import {forkJoin} from "rxjs";
import {tap} from "rxjs/operators";
import {
    SelectSearchComponentComponent
} from "../../components/select-search-api/single/select-search-component.component";
import {COMMON_FORM_IMPORTS} from "../../shared/import-groups/Common";
import {CustomChart} from "../custom-chart-form/custom-chart-form.component";


@Component({
    selector: 'context-form',
    templateUrl: './context-form.component.html',
    imports: [
    SelectSearchComponentComponent,
    COMMON_FORM_IMPORTS,
    CustomChart
],
    encapsulation: ViewEncapsulation.None
})
export class ContextFormComponent implements OnInit {
    full_series_list: any[];
    units: any[];
    series: any;
    selected_series: any[] = [];
    chart_types: any[] = [
        {name: 'Custom chart', value: 'custom-chart'},
        {name: 'Sparkline', value: 'sparkline'}
    ];
    hint: string;
    _config: SeriesSummaryConfig;
    columns: any = null;
    col_dict: any = null;

    series_changed: boolean = false;

    @Input()
    set config(config: SeriesSummaryConfig) {
        this._config = config;
    }

    get config(): SeriesSummaryConfig {
        return this._config;
    }

    constructor(private api: ApiService,
                private seriesData: SeriesDataService) {

    }

    ngOnInit() {
        if (this.config.selected_series) {
            this.api.series.getById(this.config.selected_series.id).pipe(tap(result => {
                this.series = result.data;
                this.config.series_unit = this.series.attributes.engineering_unit_name;
            })).subscribe();
        }
        // Set value defaults
        if (!this.config.primary_value) {
            this.config.primary_value = 'Value';
        }
        if (!this.config.secondary_val_1) {
            this.config.secondary_val_1 = 'Forecast';
        }
        if (!this.config.secondary_val_2) {
            this.config.secondary_val_2 = 'MTD';
        }

        this.seriesData.$estimate_types.promise.then(response => {
            let estimate_type_names = response.map(est => est.attributes.name);
            this.columns = this.seriesData.fillColumns(estimate_type_names);

            // Remove selected and deprecated columns from the available list
            this.columns.all = this.columns.columns.filter(el => {
                return !el.deprecated === true;
            }).map(el => el.name);
            this.col_dict = this.seriesData.column_dict;
        });

        forkJoin([this.api.series_light.searchMany(), this.api.engineering_unit.searchMany()]).subscribe((response) => {
            this.full_series_list = response[0].data;
            this.units = response[1].data;

        });
        if (!this.config.chart_type) {
            this.config.chart_type = 'sparkline';
        }
        if (this.config.show_header === undefined) {
            this.config.show_header = false;
        }

    }

    updateChartParams() {
        if (this.config['chart_type'] === 'custom-chart' &&
            (!this.config['chart_config'] || !Object.keys(this.config['chart_config']).length)) {
            this.config['chart_config'] = {
                labels: {
                    title: null,
                    sub_title: null,
                    y_axis: null,
                    y2_axis: null
                },
                hide_comments: false,
                series_list: [{
                    axis: 'y',
                    colour: null,
                    cumulative: null,
                    name: null,
                    show_limits: false,
                    type: 'line'
                }]
            };
            // This will only be done the first time. After that it's up to you.
            if (this.config.selected_series) {
                this.config['chart_config'].series_list[0].name = this.config.selected_series['attributes'].name;
            }
        }
    }

    matSelectCompare = function (option, value): boolean {
        if (value) {
            return option.name === value.name;
        }
    };
}
